(function () {
    'use strict';

    angular.module("imApp").factory("businessMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1143,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 1147,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
